import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-four-column',
  templateUrl: './blog-four-column.component.html',
  styleUrls: ['./blog-four-column.component.scss']
})
export class BlogFourColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
